module.exports = __webpack_public_path__ + "static/media/maternal-kinship.efaf1a88.svg";